import "core-js/modules/es.array.reverse.js";
var _class;
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { computed, makeObservable } from "mobx";
import isDefined from "../Core/isDefined";
import createStratumInstance from "../Models/Definition/createStratumInstance";
import LoadableStratum from "../Models/Definition/LoadableStratum";
import LegendTraits, { LegendItemTraits } from "../Traits/TraitsClasses/LegendTraits";

/** Merge all legend items in legends - by legend.title */
export let MergedStyleMapLegend = (_class = class MergedStyleMapLegend extends LoadableStratum(LegendTraits) {
  constructor(legends) {
    let legendItemOverrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    super();
    this.legends = legends;
    this.legendItemOverrides = legendItemOverrides;
    makeObservable(this);
  }
  duplicateLoadableStratum(_newModel) {
    return new MergedStyleMapLegend(this.legends);
  }
  get title() {
    var _this$legends$find;
    return (_this$legends$find = this.legends.find(l => l.title)) === null || _this$legends$find === void 0 ? void 0 : _this$legends$find.title;
  }
  get items() {
    const items = [];

    // Merge all Legend items by title
    this.legends.forEach(legend => {
      var _legend$items;
      (_legend$items = legend.items) === null || _legend$items === void 0 || _legend$items.forEach(currentItem => {
        const existingItemIndex = items.findIndex(item => item.title && item.title === currentItem.title);
        const existingItem = items[existingItemIndex];
        if (!existingItem) {
          items.push(createStratumInstance(LegendItemTraits, _objectSpread(_objectSpread({}, this.legendItemOverrides), currentItem)));
        } else {
          items[existingItemIndex] = _objectSpread(_objectSpread(_objectSpread({}, this.legendItemOverrides), existingItem), Object.entries(currentItem).reduce((acc, _ref) => {
            let [key, value] = _ref;
            if (isDefined(value)) {
              acc[key] = value;
            }
            return acc;
          }, {}));
        }
      });
    });
    return items;
  }
}, _applyDecoratedDescriptor(_class.prototype, "title", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "title"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "items", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "items"), _class.prototype), _class);